module.exports = __webpack_public_path__ + "media/images/categories/headers/marketing-f370d95b94b438b0c16072b3e7a4ddbd.jpg";